<template>
  <div id="section-to-print">
    <div v-for="cabang in cabangs" :key="cabang.id">
      <!-- Render this div if cabang.id is equal to 1 -->
      <div v-if="cabang.id === 1">
        <!-- Content for cabang with id 1 -->
        <!-- iteration bagians -->
        <div v-for="bagian in bagians" :key="bagian.id">
          <div class="row add-page-break-after">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h5 style="font-weight: bold">
                      PERUSAHAAN UMUM DAERAH AIR MINUM
                    </h5>
                    <h5 style="font-weight: bold">TIRTA HITA BULELENG</h5>
                    <h4 class="header-title">
                      <strong
                        >DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN CABANG
                        {{ toUpper(cabang.nama) }} BAGIAN
                        {{ toUpper(bagian.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong>UNTUK BULAN: JUNI 2023</strong>
                    </h5>

                    <table class="table" v-if="gajis">
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3">
                            NAMA<br />
                            <br />NIP/NIK<br />JABATAN
                          </th>
                          <th rowspan="3" colspan="2">GOL.</th>
                          <th rowspan="2">GAJI POKOK</th>
                          <th colspan="7" rowspan="1">TUNJANGAN</th>
                          <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                          <th rowspan="2">JUMLAH BRUTO</th>
                          <th rowspan="2">TUNJANGAN PPH</th>
                          <th rowspan="2">JUMLAH (14+15)</th>
                          <th rowspan="1" colspan="5">POTONGAN</th>
                          <th rowspan="3">JUMLAH YANG DITERIMA</th>
                          <th rowspan="3" colspan="2">TANDA TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>
                            PERUSAHAAN
                            <div class="small-text">(5)x 25%</div>
                          </th>
                          <th>JABATAN</th>
                          <th>
                            KEMAHALAN
                            <div class="small-text">(5)x 5%</div>
                          </th>
                          <th>AIR</th>
                          <th>TRANSPORT</th>
                          <th>PANGAN</th>
                          <th>KESEHATAN</th>
                          <th>HARI</th>
                          <th>
                            JUMLAH
                            <div class="small-text">13X5%(6+10)</div>
                          </th>
                          <th>KESEHATAN</th>
                          <th>
                            BPJS TK 3 PROGRAM
                            <div class="small-text">(15)X2%</div>
                          </th>
                          <th>
                            BPJS TK 4 PROGRAM
                            <div class="small-text">
                              (Bts maxX1% JP)+ 2% JHT
                            </div>
                          </th>
                          <th>PENSIUN JIWASRAYA</th>
                          <th>PPH</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                          <th>18</th>
                          <th>19</th>
                          <th>20</th>
                          <th>20</th>
                          <th>21</th>
                          <th>22</th>
                          <th></th>
                          <th>24</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- TODO -->
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'cabang_id'],
                                val: cabang.id,
                              },
                              {
                                indexs: ['riwayat_pekerjaan', 'bagian_id'],
                                val: bagian.id,
                              },
                            ],
                            'sub_bagian_id'
                          )"
                          :key="item.id"
                          :class="getPageBreakStyle(index)"
                        >
                          <!-- :class="'top-text table-row-vfor'"
                          :style="getPageBreakStyle(index)" -->
                          <td style="border: 1px solid #000">
                            <span
                              :style="printNewLine(item.print_sub_bagian)"
                              v-if="subBagians"
                            >
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td style="border: 1px solid #000">
                            <div :style="boldStyle" v-if="shoudRenderSubBagian">
                              {{
                                printSubBagian(
                                  item.print_sub_bagian,
                                  item.riwayat_pekerjaan
                                )
                              }}
                            </div>
                            {{ item.pegawai.nama }} <br />
                            <br />NIK.
                            {{ item.pegawai.nik }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            <!-- style="white-space: pre-line" -->
                            <!-- {{ item.golongan.nama }} -->
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ item.pegawai.status_ptkp }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.gaji_pokok) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_perusahaan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_jabatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kemahalan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_air) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_transport) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pangan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{
                              formatNumber(item.pot_5_persen + item.jml_bruto)
                            }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pensiun) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.total_diterima) }}
                          </td>
                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                          >
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td class="bottom-text">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span
                            >...............
                          </td>
                        </tr>
                      </tbody>
                      <!-- <tfoot> -->
                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajis.totalGajis"
                      >
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          JUMLAH
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.gaji_pokok) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_perusahaan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_jabatan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_kemahalan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_air) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_transport) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_pangan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_kesehatan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.jml_tdk_hadir) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.pot_5_persen) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.jml_bruto) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_pph) }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            formatNumber(
                              gajis.totalGajis.pot_5_persen +
                                gajis.totalGajis.jml_bruto
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.pot_kesehatan) }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            formatNumber(
                              gajis.totalGajis.pot_bpjs_tk_tiga_program
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            formatNumber(
                              gajis.totalGajis.pot_bpjs_tk_empat_program
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.pot_pensiun) }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.pot_pph) }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.total_diterima) }}
                        </td>
                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                      <tr></tr>
                      <!-- <tr>
                        <td colspan="24" class="no-border-terbilang">
                          Terbilang : -----
                          {{
                            formatNumberTerbilang(
                              gajis.totalGajis.pot_5_persen +
                                gajis.totalGajis.jml_bruto
                            )
                          }}
                          Rupiah -----
                        </td>
                      </tr> -->
                      <!-- <tr>
                        <td colspan="24" class="no-border-terbilang">
                          <div class="row">
                            <div class="col-6">
                              Terbilang : -----
                              {{
                                formatNumberTerbilang(
                                  gajis.totalGajis.pot_5_persen +
                                    gajis.totalGajis.jml_bruto
                                )
                              }}
                              Rupiah -----
                              <br />
                              Perumda Air Minum <br />
                              Tirta Hita Buleleng <br />
                              Menyetujui: <br />
                              <br />
                              <br />
                              <div
                                style="
                                  text-decoration: underline;
                                  padding-top: 35px;
                                "
                                v-if="pejabatMengetahui"
                              >
                                {{ pejabatMengetahui.nama }}
                              </div>

                              Direktur Umum
                            </div> -->
                      <!-- <div class="col-6">
                              <br />
                              <br />
                              <div v-if="gajis">
                                Singaraja,
                                {{ convertTgl(gajis.gajis[0].created_at) }}
                              </div>

                              Dibuat Oleh:<br />
                              <br />
                              <br />
                              <div
                                style="
                                  text-decoration: underline;
                                  padding-top: 35px;
                                "
                                v-if="pejabatMembuat"
                              >
                                {{ pejabatMembuat.nama }}
                              </div>
                              Ka. Sub Bag. Personalia
                            </div>
                          </div>
                        </td>
                      </tr> -->
                    </table>
                    <div class="row" v-if="gajis">
                      <div class="col-12">
                        <p>
                          <!-- {{ formatNumber(gajis.totalGajis.pot_pph) }} -->
                          Terbilang : -----
                          {{
                            formatNumberTerbilang(
                              gajis.totalGajis.pot_5_persen +
                                gajis.totalGajis.jml_bruto
                            )
                          }}
                          Rupiah -----
                        </p>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          Perumda Air Minum <br />
                          Tirta Hita Buleleng <br />
                          Menyetujui: <br />
                          <br />
                          <br />
                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMengetahui"
                          >
                            {{ pejabatMengetahui.nama }}
                          </div>

                          Direktur Umum
                        </div>
                        <div class="col-6">
                          <br />
                          <div v-if="gajis">
                            Singaraja,
                            {{ convertTgl(gajis.gajis[0].created_at) }}
                          </div>

                          Dibuat Oleh:<br />
                          <br />
                          <br />
                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMembuat"
                          >
                            {{ pejabatMembuat.nama }}
                          </div>
                          Ka. Sub Bag. Personalia
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>

        <div v-for="bidang in bidangs" :key="bidang.id">
          <div class="row add-page-break-after">
            <div class="col-12">
              <div class="p-3 mb-3">
                <div class="row">
                  <div class="col-12">
                    <h5 style="font-weight: bold">
                      PERUSAHAAN UMUM DAERAH AIR MINUM
                    </h5>
                    <h5 style="font-weight: bold">TIRTA HITA BULELENG</h5>
                    <h4 class="header-title">
                      <strong
                        >DAFTAR PEMBAYARAN GAJI DAN TUNJANGAN CABANG
                        {{ toUpper(cabang.nama) }} BIDANG
                        {{ toUpper(bidang.nama) }}
                      </strong>
                    </h4>
                    <h5 class="header-periode" style="padding-bottom: 20px">
                      <strong>UNTUK BULAN: JUNI 2023</strong>
                    </h5>

                    <table class="table" v-if="gajis">
                      <thead>
                        <tr class="center-top-text">
                          <th rowspan="3">NO</th>
                          <th rowspan="3">
                            NAMA<br />
                            <br />NIP/NIK<br />JABATAN
                          </th>
                          <th rowspan="3" colspan="2">GOL.</th>
                          <th rowspan="2">GAJI POKOK</th>
                          <th colspan="7" rowspan="1">TUNJANGAN</th>
                          <th colspan="2" rowspan="1">POT. KETIDAKHADIRAN</th>
                          <th rowspan="2">JUMLAH BRUTO</th>
                          <th rowspan="2">TUNJANGAN PPH</th>
                          <th rowspan="2">JUMLAH (14+15)</th>
                          <th rowspan="1" colspan="5">POTONGAN</th>
                          <th rowspan="3">JUMLAH YANG DITERIMA</th>
                          <th rowspan="3" colspan="2">TANDA TANGAN</th>
                        </tr>

                        <tr class="center-top-text">
                          <th>
                            PERUSAHAAN
                            <div class="small-text">(5)x 25%</div>
                          </th>
                          <th>JABATAN</th>
                          <th>
                            KEMAHALAN
                            <div class="small-text">(5)x 5%</div>
                          </th>
                          <th>AIR</th>
                          <th>TRANSPORT</th>
                          <th>PANGAN</th>
                          <th>KESEHATAN</th>
                          <th>HARI</th>
                          <th>
                            JUMLAH
                            <div class="small-text">13X5%(6+10)</div>
                          </th>
                          <th>KESEHATAN</th>
                          <th>
                            BPJS TK 3 PROGRAM
                            <div class="small-text">(15)X2%</div>
                          </th>
                          <th>
                            BPJS TK 4 PROGRAM
                            <div class="small-text">
                              (Bts maxX1% JP)+ 2% JHT
                            </div>
                          </th>
                          <th>PENSIUN JIWASRAYA</th>
                          <th>PPH</th>
                        </tr>

                        <tr class="center-top-text">
                          <th style="border: none">(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                          <th>(Rp.)</th>
                        </tr>
                        <tr class="center-top-text">
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                          <th>18</th>
                          <th>19</th>
                          <th>20</th>
                          <th>20</th>
                          <th>21</th>
                          <th>22</th>
                          <th></th>
                          <th>24</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- TODO -->
                        <tr
                          v-for="(item, index) in filterGajisByConditions(
                            [
                              {
                                indexs: ['riwayat_pekerjaan', 'cabang_id'],
                                val: cabang.id,
                              },
                              {
                                indexs: ['riwayat_pekerjaan', 'bidang_id'],
                                val: bidang.id,
                              },
                            ],
                            'sub_bidang_id'
                          )"
                          :key="item.id"
                          :class="getPageBreakStyle(index)"
                        >
                          <!-- :class="'top-text table-row-vfor'"
                          :style="getPageBreakStyle(index)" -->
                          <td style="border: 1px solid #000">
                            <span
                              :style="printNewLine(item.print_sub_bagian)"
                              v-if="subBidangs"
                            >
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td style="border: 1px solid #000">
                            <div :style="boldStyle" v-if="shoudRenderSubBagian">
                              {{
                                printSubBagian(
                                  item.print_sub_bagian,
                                  item.riwayat_pekerjaan
                                )
                              }}
                            </div>
                            {{ item.pegawai.nama }} <br />
                            <br />NIK.
                            {{ item.pegawai.nik }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            <!-- style="white-space: pre-line" -->
                            <!-- {{ item.golongan.nama }} -->
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ item.pegawai.status_ptkp }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.gaji_pokok) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_perusahaan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_jabatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kemahalan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_air) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_transport) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pangan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_kesehatan) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_tdk_hadir) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_5_persen) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.jml_bruto) }}
                          </td>

                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.tun_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{
                              formatNumber(item.pot_5_persen + item.jml_bruto)
                            }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_kesehatan) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_tiga_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_bpjs_tk_empat_program) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pensiun) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.pot_pph) }}
                          </td>
                          <td style="border: 1px solid #000">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ formatNumber(item.total_diterima) }}
                          </td>
                          <td
                            style="border: 1px solid #000"
                            class="bottom-text"
                          >
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span>
                            {{ index + 1 }}
                          </td>
                          <td class="bottom-text">
                            <span :style="printNewLine(item.print_sub_bagian)">
                            </span
                            >...............
                          </td>
                        </tr>
                      </tbody>
                      <!-- <tfoot> -->
                      <tr
                        class="top-text table-row-vfor"
                        v-if="gajis.totalGajis"
                      >
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000; font-weight: bold">
                          JUMLAH
                        </td>
                        <td style="border: 1px solid #000"></td>
                        <td style="border: 1px solid #000"></td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.gaji_pokok) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_perusahaan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_jabatan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_kemahalan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_air) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_transport) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_pangan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_kesehatan) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.jml_tdk_hadir) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.pot_5_persen) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.jml_bruto) }}
                        </td>

                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.tun_pph) }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            formatNumber(
                              gajis.totalGajis.pot_5_persen +
                                gajis.totalGajis.jml_bruto
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.pot_kesehatan) }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            formatNumber(
                              gajis.totalGajis.pot_bpjs_tk_tiga_program
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{
                            formatNumber(
                              gajis.totalGajis.pot_bpjs_tk_empat_program
                            )
                          }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.pot_pensiun) }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.pot_pph) }}
                        </td>
                        <td style="border: 1px solid #000">
                          {{ formatNumber(gajis.totalGajis.total_diterima) }}
                        </td>
                        <td
                          style="border: 1px solid #000"
                          class="bottom-text"
                        ></td>
                        <td class="bottom-text"></td>
                      </tr>
                      <tr></tr>
                      <!-- <tr>
                        <td colspan="24" class="no-border-terbilang">
                          Terbilang : -----
                          {{
                            formatNumberTerbilang(
                              gajis.totalGajis.pot_5_persen +
                                gajis.totalGajis.jml_bruto
                            )
                          }}
                          Rupiah -----
                        </td>
                      </tr> -->
                      <!-- <tr>
                        <td colspan="24" class="no-border-terbilang">
                          <div class="row">
                            <div class="col-6">
                              Terbilang : -----
                              {{
                                formatNumberTerbilang(
                                  gajis.totalGajis.pot_5_persen +
                                    gajis.totalGajis.jml_bruto
                                )
                              }}
                              Rupiah -----
                              <br />
                              Perumda Air Minum <br />
                              Tirta Hita Buleleng <br />
                              Menyetujui: <br />
                              <br />
                              <br />
                              <div
                                style="
                                  text-decoration: underline;
                                  padding-top: 35px;
                                "
                                v-if="pejabatMengetahui"
                              >
                                {{ pejabatMengetahui.nama }}
                              </div>

                              Direktur Umum
                            </div> -->
                      <!-- <div class="col-6">
                              <br />
                              <br />
                              <div v-if="gajis">
                                Singaraja,
                                {{ convertTgl(gajis.gajis[0].created_at) }}
                              </div>

                              Dibuat Oleh:<br />
                              <br />
                              <br />
                              <div
                                style="
                                  text-decoration: underline;
                                  padding-top: 35px;
                                "
                                v-if="pejabatMembuat"
                              >
                                {{ pejabatMembuat.nama }}
                              </div>
                              Ka. Sub Bag. Personalia
                            </div>
                          </div>
                        </td>
                      </tr> -->
                    </table>
                    <div class="row" v-if="gajis">
                      <div class="col-12">
                        <p>
                          <!-- {{ formatNumber(gajis.totalGajis.pot_pph) }} -->
                          Terbilang : -----
                          {{
                            formatNumberTerbilang(
                              gajis.totalGajis.pot_5_persen +
                                gajis.totalGajis.jml_bruto
                            )
                          }}
                          Rupiah -----
                        </p>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          Perumda Air Minum <br />
                          Tirta Hita Buleleng <br />
                          Menyetujui: <br />
                          <br />
                          <br />
                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMengetahui"
                          >
                            {{ pejabatMengetahui.nama }}
                          </div>

                          Direktur Umum
                        </div>
                        <div class="col-6">
                          <br />
                          <div v-if="gajis">
                            Singaraja,
                            {{ convertTgl(gajis.gajis[0].created_at) }}
                          </div>

                          Dibuat Oleh:<br />
                          <br />
                          <br />
                          <div
                            style="
                              text-decoration: underline;
                              padding-top: 35px;
                            "
                            v-if="pejabatMembuat"
                          >
                            {{ pejabatMembuat.nama }}
                          </div>
                          Ka. Sub Bag. Personalia
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /col-12  -->
          </div>
        </div>
        <!-- end of v-for bagians -->
      </div>
      <!-- end of cabang = 1 -->
    </div>
    <!-- /v-for cabang -->

    <!-- /////////////////////////////////HONOR//////////////////////////////////////////// -->
  </div>
  <!-- /section-to-print -->
</template>

<style scoped lang="scss">
// FIX!
.table-row-vfor {
  border: 1px solid #000;
  // border-left: 1px solid #000;
}

.center-top-text {
  vertical-align: top; /* Align text to the top */
  text-align: center; /* Center text horizontally */
}

.top-text {
  vertical-align: top;
}
.bottom-text {
  vertical-align: bottom;
}

.small-text {
  font-size: 8px;
}
.header-title {
  text-align: center;
}
.header-periode {
  text-align: center;
}

.add-page-break-before {
  page-break-before: always;
}
.add-page-break-after {
  page-break-after: always;
}

// /FIX!

.table {
  width: 100%;
  border: 1px solid #000; /* Adjust the border thickness as needed */
  border: collapse;
  // table-layout: fixed;
}
.table th,
.table td {
  border: 1px solid #000; /* Adjust the border thickness as needed */
  padding: 0;
}

td {
  page-break-inside: avoid !important;
}

.no-border-terbilang {
  border-top: 1px solid #000 !important;
  border-style: hidden !important;
}
@media print {
  // table {
  //   page-break-inside: avoid;
  // } lama
  table {
    page-break-inside: auto;
  }

  tr {
    break-inside: avoid;
  }
  // tbody {
  //   display: block;
  // }
}
</style>
<script>
import axios from "axios";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import _ from "lodash";
import { DateTime } from "luxon";
export default {
  // Component logic goes here
  data() {
    return {
      gajis: null,
      gajiTetap: null,
      pejabatMengetahui: null,
      pejabatMembuat: null,
      cabangs: null,
      bagians: null,
      bidangs: null,
      subBagians: null,
      subBidangs: null,
      seksis: null,
      totalRows: 0,
      previousSubBagianId: null,
    };
  },
  async mounted() {
    //gajitetap
    //per cabang, per bagian
    await this.fetchDataSubBagian();
    await this.fetchDataSubBidang();
    await this.fetchDataSeksi();
    this.gajis = await this.fetchDataGaji([2, 5], "2023-06-01");
    await this.fetchDataPejabatPembuatGaji();
    await this.fetchDataCabang();
    await this.fetchDataBagian();
    await this.fetchDataBidang();

    // this.gajis =
    // console.log("hello", this.gajis);
    console.log("MOUNTED subBagians", this.subBagians);
    // this.storeDireksi = await this.fetchData(1);
  },
  computed: {
    shoudRenderSubBagian() {
      console.log("SHOULDRENDERSUBBAGIAN subBagians", this.subBagians);
      const condition1 = this.subBagians !== null;
      const condition2 = this.subBidangs !== null;
      const condition3 = this.seksis !== null;
      console.log(
        "SHOULDRENDERSUBBAGIAN " +
          condition1 +
          " " +
          condition2 +
          " " +
          condition3
      );
      return condition1 && condition2 && condition3; //salah satu tidak null
    },
    boldStyle() {
      // Define inline styles to make the text bold
      return {
        fontWeight: "bold",
      };
    },
  },
  methods: {
    printNewLine(print) {
      if (print)
        return {
          display: "block",
          whiteSpace: "pre-line",
          height: "1em",
        };
      else
        return {
          display: "inline",
        };
    },

    printSubBagian(print, riwayatPekerjaan) {
      console.log("printSubBagian RIWAYATPEKERJAAN", riwayatPekerjaan);
      var result = null;

      if (print) {
        console.log("printSubBagian masukprint");
        if (riwayatPekerjaan.sub_bagian_id !== null)
          result = _.find(this.subBagians, {
            id: riwayatPekerjaan.sub_bagian_id,
          });
        if (riwayatPekerjaan.sub_bidang_id !== null)
          result = _.find(this.subBidangs, {
            id: riwayatPekerjaan.sub_bidang_id,
          });
        if (riwayatPekerjaan.seksi_id !== null)
          result = _.find(this.seksis, {
            id: riwayatPekerjaan.seksi_id,
          });

        // const result = _.find(this.subBagians, { id: subBagianId });

        // console.log("PRINTSUBBAGIAN subBagianId", subBagianId);
        console.log("printSubBagian result", result);
        return result.nama;
        // return "PRINT SUBBAGIAN/SEKSI";
      }
    },

    convertTgl(inputDate) {
      const parsedDate = DateTime.fromISO(inputDate);

      // Format the date in the desired Indonesian format
      const formattedDate = parsedDate.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      return formattedDate;
    },
    async fetchDataGaji(pegawaiStatusId, tglGaji) {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      const data = {
        pegawai_status_ids: pegawaiStatusId,
        tgl_gaji: tglGaji,
      };
      console.log(data);
      try {
        const response = await axios.post(
          "http://127.0.0.1/api/get_gaji",
          data,
          config
        );

        return response.data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchDataPejabatPembuatGaji() {
      try {
        const response = await axios.get("http://127.0.0.1/api/pejabat_gaji");
        this.gaji = response.data.gajis;
        this.pejabatMengetahui = response.data.dirum;
        this.pejabatMembuat = response.data.kasubagPersonalia;
        // console.log("HASIL pejabatMengetahui", this.pejabatMengetahui);
        // console.log("HASIL SUMGAJIS", this.sumgajis);
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    formatNumberTerbilang(value) {
      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];
        // console.log(angkaTerbilang(stringValue));
        return _.startCase(angkaTerbilang(stringValue));
        // Add thousands separator
        // return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    formatNumber(value) {
      // if (value) {
      //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      // }
      // return value;
      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];

        // Add thousands separator
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },
    async fetchDataCabang() {
      try {
        const response = await axios.get("http://127.0.0.1/api/cabang");
        this.cabangs = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataBagian() {
      try {
        const response = await axios.get("http://127.0.0.1/api/bagian");
        this.bagians = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataBidang() {
      try {
        const response = await axios.get("http://127.0.0.1/api/bidang");
        this.bidangs = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataSubBagian() {
      try {
        const response = await axios.get("http://127.0.0.1/api/subBagian");
        this.subBagians = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataSeksi() {
      try {
        const response = await axios.get("http://127.0.0.1/api/seksi");
        this.seksis = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDataSubBidang() {
      try {
        const response = await axios.get("http://127.0.0.1/api/subBidang");
        this.subBidangs = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    toUpper(val) {
      return _.toUpper(val);
    },
    filterGajisByConditions(conditions, groupByCol) {
      console.log("GROUPBYCOL ", groupByCol);
      // console.log("FILTERGAJIBYCONDITIONS", conditions);
      var filteredItems = this.getFilteredGajis(conditions);
      // console.log("HASIL FILTER GAJI", filteredItems);
      this.totalRows = filteredItems.length;
      var hasil = filteredItems;

      const sortedData = _.orderBy(
        hasil,
        "riwayat_pekerjaan.jabatan_id",
        "asc"
      );
      // Separate rows with sub_bagian: null
      const rowsWithNullSubBagian = _.filter(sortedData, (item) => {
        const condition1 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 4; //cabang
        const condition2 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 5; //bagian
        const condition3 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 6; //bidang
        const condition4 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 9; //unit

        return condition1 || condition2 || condition3 || condition4;
      }); //kabag/kacab/kaunit/kabid

      // const dataWithoutNullSubBagian = _.reject(
      //   sortedData,
      //   (item) => _.get(item, "riwayat_pekerjaan.sub_bagian_id") === null
      // ); //pegawai biasa. INI OKE
      // const dataWithoutNullSubBagian = _.reject(
      //   sortedData,
      //   (item) => _.get(item, "riwayat_pekerjaan.jabatan_id") === 5
      // ); //pegawai biasa. INI belum OKE

      const dataWithoutNullSubBagian = _.reject(sortedData, (item) => {
        // Define your conditions using logical operators (&&, ||)
        const condition1 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 4; //cabang
        const condition2 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 5; //bagian
        const condition3 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 6; //bidang
        const condition4 = _.get(item, "riwayat_pekerjaan.jabatan_id") == 9; //unit

        return condition1 || condition2 || condition3 || condition4;
      }); //staf/kasubid/kasubag/kaseksi

      // console.log("NEW conditions", conditions);
      // console.log("NEW", dataWithoutNullSubBagian);

      // const groupBySubBagianId = _.groupBy(
      //   dataWithoutNullSubBagian,
      //   "riwayat_pekerjaan.${groupByCol}"
      // ); //group by sub bagian id
      const groupByKey = `riwayat_pekerjaan.${groupByCol}`;
      const groupBySubBagianId = _.groupBy(
        dataWithoutNullSubBagian,
        groupByKey
      ); //group by sub bagian id

      console.log("GROUP BY", groupBySubBagianId);

      // const groupBySubBagianId = _.groupBy(
      //   dataWithoutNullSubBagian,
      //   "riwayat_pekerjaan.sub_bagian_id"//sub_bidang
      // ); //group by sub bagian id

      // const groupBySubBagianId = _.groupBy(
      //   dataWithoutNullSubBagian,
      //   "riwayat_pekerjaan.sub_bagian_id"seksi
      // ); //group by sub bagian id

      // const groupBySubBagianId = _.groupBy(
      //   dataWithoutNullSubBagian,
      //   "riwayat_pekerjaan.sub_bagian_id"
      // ); //group by sub bagian id

      for (const subBagianId in groupBySubBagianId) {
        groupBySubBagianId[subBagianId] = _.orderBy(
          groupBySubBagianId[subBagianId],
          ["riwayat_pekerjaan.jabatan_id", "pegawai.nik"],
          ["asc", "asc"]
        );
        _.forEach(groupBySubBagianId[subBagianId], (value, index, array) => {
          // Modify the value (for example, double it)
          if (index == 0) array[index].print_sub_bagian = true;
          else array[index].print_sub_bagian = false;
        });

        console.log("groupBySubBagianId >> ", groupBySubBagianId[subBagianId]);
      } //order by jabatanid, and then pegawai nik

      var flatGroupBySubBagianId = _.flatten(Object.values(groupBySubBagianId));

      var akhir = _.concat(rowsWithNullSubBagian, flatGroupBySubBagianId); //gabungkan sorted pegawai dengan kabag

      const flattenedData = _.flatten(Object.values(akhir));

      console.log("FILTER FINAL", flattenedData);
      return flattenedData;
    },
    getFilteredGajis(conditions) {
      return this.gajis.gajis.filter((item) => {
        // Check if all conditions are met
        return conditions.every((condition) => {
          // Initialize a variable to keep track of the current property value
          let currentPropertyValue = item;

          // Use a loop to traverse the nested properties if there are any
          for (const index of condition.indexs) {
            // Check if the current property exists in the object
            if (
              Object.prototype.hasOwnProperty.call(currentPropertyValue, index)
            ) {
              // if (currentPropertyValue.hasOwnProperty(index)) {
              // If the current item has the current property, update currentPropertyValue
              currentPropertyValue = currentPropertyValue[index];
            } else {
              // If the property is not found, return false (don't include in the result)
              return false;
            }
          }

          // Check if the final currentPropertyValue matches the provided value
          return currentPropertyValue === condition.val;
        });
      });
    },

    getPageBreakStyle(index) {
      var rowSaatIni = index + 1;
      if (rowSaatIni === 7)
        return "top-text table-row-vfor add-page-break-after"; //page break di tr ke 7
      if (rowSaatIni % 8 === 0)
        return "top-text table-row-vfor add-page-break-before";
      return "top-text table-row-vfor";
    },
  },
};
</script>
